import mixins from '@/mixins'
import validation from '@/mixins/validation'
import { mapActions, mapGetters } from 'vuex'

export default {
    name: 'setting-analysis-options-general',
    mixins: [mixins, validation],
    data () {
        return {
            valid: false,
            payload: {
                key: '',
                lang: '',
                group: '',
                sort: 0,
                value: ''
            },
            keyRules: [
                v => !!v || 'Key is required'
            ],
            langRules: [
                v => !!v || 'Lang is required'
            ],
            groupRules: [
                v => !!v || 'Group is required'
            ],
            sortRules: [
                v => (v !== null && v !== undefined && v !== '') || 'Sort is required',
                v => Number.isInteger(Number(v)) && Number(v) >= 0 || 'Sort must be a non-negative integer'
            ],
            valueRules: [
                v => (v !== null && v !== undefined && String(v).length > 0) || 'Value is required'
            ]
        }
    },
    watch: {
        currentItem () {
            if (this.currentItem && this.editId) {
                this.setData()
            }
        }
    },
    computed: {
        ...mapGetters({
            isLoading: 'settingAnalysisOptions/isLoading',
            currentItem: 'settingAnalysisOptions/currentItem',
            editId: 'settingAnalysisOptions/editId'
        })
    },
    created () {
        if (this.currentItem && this.editId) {
            this.setData()
        }
    },
    methods: {
        ...mapActions({
            update: 'settingAnalysisOptions/UPDATE',
            create: 'settingAnalysisOptions/CREATE'
        }),
        setData () {
            if (!this.currentItem) {
                return
            }

            this.payload = {
                key: this.currentItem.key || '',
                lang: this.currentItem.lang || '',
                group: this.currentItem.group || '',
                sort: this.currentItem.sort != null ? Number(this.currentItem.sort) : 0,
                value: this.currentItem.value != null ? String(this.currentItem.value) : ''
            }
        },
        buildPayload () {
            return {
                key: this.payload.key,
                lang: this.payload.lang,
                group: this.payload.group,
                sort: Number(this.payload.sort),
                value: this.payload.value
            }
        },
        resetForm () {
            this.payload = {
                key: '',
                lang: '',
                group: '',
                sort: 0,
                value: ''
            }

            this.$nextTick(() => {
                if (this.$refs.form) {
                    this.$refs.form.reset()
                }
            })
        },
        submit () {
            this.$refs.form.validate()

            if (!this.valid) {
                return
            }

            const body = this.buildPayload()

            if (this.editId) {
                this.update(body).then(() => {
                    this.$toasted.success(this.$t('success_updated'))
                    this.$emit('saved')
                })
            } else {
                this.create(body).then(() => {
                    this.$toasted.success(this.$t('success_created'))
                    this.resetForm()
                    this.$emit('saved')
                })
            }
        }
    }
}
